<template>
    <a-dropdown :trigger="['click']" style="background-color:#fff;height:50px;width: 90px;padding-left:10px;padding-top:2px;border-radius:45px" overlayClassName="header-notifications-dropdown" :getPopupContainer="() => wrapper">
                    
        <a-badge>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()" >
                <img class="profile_img" :src="profileImage" style="height:45px;width:45px;border-radius:90px" alt="" />
                <img class="chevron_down" src="/images/chevron-down.svg" style="height:15px;width:15px;margin-left: 8px;" alt="" />
            </a>
        </a-badge>
        
        <a-list item-layout="horizontal" style="background: #ffffff;box-shadow: 0px 20px 27px rgba(0, 0, 0, 0.05);border-radius: 12px;min-width: 176px;padding: 16px 8px;" class="header-notifications-list" slot="overlay">
            <a-list-item>
                <a-list-item-meta>
                    <template #description>
                        <span>{{ role }}</span>
                    </template>
                    <a slot="title" href="#"> {{ fullName }} </a>
                    <a-avatar
                        slot="avatar"
                        shape="square"
                        :src="profileImage"
                    />
                </a-list-item-meta>
            </a-list-item>
            <a-list-item>
                <a-list-item-meta>
                    <a slot="title" href="#" @click="$refs.changePasswordModal.showModal()" style="margin-top: 20px;"> 
                        {{ $t('profile-actions.change-password') }}
                    </a>
                    <a-avatar
                        slot="avatar"
                        shape="square"
                        src="/images/icon-password.png"
                    />
                </a-list-item-meta>

                <ChangePasswordModal 
                    ref="changePasswordModal"
                >
                </ChangePasswordModal>

            </a-list-item>

            <a-list-item>
                <a-list-item-meta>
                    <a slot="title" href="#" @click.prevent="performSignOut" style="margin-top: 20px;"> {{ $t('profile-actions.signout') }} </a>
                    <a-avatar
                        slot="avatar"
                        shape="square"
                        src="/images/signout.png"
                    />
                </a-list-item-meta>
            </a-list-item>
            
        </a-list>
    </a-dropdown>
</template>
<script>

import { useAuthStore } from '../../stores/auth-store';
import { mapActions, mapState } from 'pinia';
import { navigationMixin } from "../../mixins/navigation-mixin.js";
import ChangePasswordModal from "../modal/ChangePasswordModal.vue";

export default {
    components:{
        ChangePasswordModal,
    },
    mixins: [ navigationMixin ],
    data() {
        return {
            wrapper: document.body,
            visible: false,
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'currentUser', 'profile' ]),
        fullName(){
            if (this.currentUser){
                return this.currentUser.fullName;
            }
            return '';
        },
        role() {
            if (this.currentUser){
                let role = this.currentUser.roles[0];
                if (role == 'USER') {
                    return 'Visitor';
                } else if (role == 'OWNER') {
                    return 'Admin'
                } else if (role == 'ICT') {
                    return 'ICT';
                } else if (role == 'OFFICIAL') {
                    return 'Official';
                }
                return '';
            }
        },
        profileImage(){
            if (this.profile && this.profile.imageUrl && this.profile.imageUrl.length > 0){
                return this.profile.imageUrl;
            }
            return ("/images/default-avatar.jpg");
        }
    },
    methods: {
         ...mapActions(useAuthStore, [ 'signOut' ]),
        performSignOut() {
            this.signOut().then(() => {
                this.navigateTo('Index', {});
            });
        },
        
    }
}
</script>